/**
 * „Offen für dich“ auf der Übersicht: was in den Richtlinien auf den Nutzer wartet — vom Server aus
 * Rollen und Bestand berechnet (Ausgaben zur Freigabe, Vorschläge, Anforderungen, Verknüpfungen,
 * Kommentarfäden mit neuer Antwort). Ein Klick öffnet die Richtlinie an der passenden Stelle.
 */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";

import { useGuidelinesAPI, type InboxItem } from "./GuidelinesAPI";
import { displayTitle, GUIDELINES_PATH } from "./guidelinesPath";

const TAB: Record<InboxItem["kind"], string | null> = { edition: null, suggestions: "suggestions", requirements: "requirements", links: "links", comments: "comments" };

export function InboxPanel({ customer }: { customer: string }) {
  const { t } = useTranslation();
  const api = useGuidelinesAPI(customer);
  const navigate = useNavigate();
  const [items, setItems] = useState<InboxItem[] | null>(null);

  useEffect(() => {
    // Ohne Posteingang bleibt die Übersicht, wie sie ist — kein Fehlerhinweis.
    api.getInbox().then(setItems, () => setItems([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customer]);

  if (!items?.length) return null;
  const open = (i: InboxItem) => {
    const params = new URLSearchParams();
    if (i.section) params.set("section", i.section);
    if (TAB[i.kind]) params.set("tab", TAB[i.kind]!);
    if (i.kind === "edition") params.set("edition", "open");
    navigate(`${GUIDELINES_PATH}/${i.documentId}${params.toString() ? `?${params}` : ""}`);
  };
  return (
    <div className="rounded-lg border bg-card" data-testid="inbox">
      <div className="flex items-center gap-2 border-b px-3 py-2 text-sm font-semibold">
        <Bell size={14} />
        {t("guidelinesPage.inbox.title")}
      </div>
      {items.map((i, n) => (
        <button key={n} type="button" onClick={() => open(i)} className="flex w-full items-baseline gap-2 border-b px-3 py-2 text-left text-sm last:border-b-0 hover:bg-accent" data-inbox={i.kind}>
          <span className="min-w-0 flex-1">{t(`guidelinesPage.inbox.${i.kind}`, { count: i.count, label: i.label ?? "", section: i.section ?? "" })}</span>
          <span className="shrink-0 text-xs text-muted-foreground">{displayTitle(i.documentTitle)}</span>
        </button>
      ))}
    </div>
  );
}
